import styled from '@emotion/styled';
import { Form } from 'react-bootstrap';

const Feedback = styled(Form.Control.Feedback)({ display: 'block' });

export default Feedback;
